import {ISimpleColor} from '@consts/types';

const createColor = (): ISimpleColor => ({
  alpha: 1,
  red: Math.round(255 * Math.random()),
  green: Math.round(255 * Math.random()),
  blue: Math.round(255 * Math.random()),
})

export default createColor;